<template>
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="120px">
        <el-form-item label="汇总方式" prop="sum_type" required>
            <el-select v-model="formData.sum_type">
                <el-option label="天" value="day"></el-option>
                <el-option label="周" value="week"></el-option>
                <el-option label="月" value="month"></el-option>
                <el-option label="季度" value="quarter"></el-option>
                <el-option label="年" value="year"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="排序条件" prop="order_by" required>
            <ESelect v-model="formData.order_by">
                <el-option 
                    v-for="item in joinOptionFieldsList"
                    :key="item.name"
                    :label="item.display_name"
                    :value="item.name"
                />
            </ESelect>
        </el-form-item>
        <el-form-item label="排序方式" prop="order_type" required>
            <el-radio-group v-model="formData.order_type">
                <el-radio  label="desc">降序</el-radio>
                <el-radio  label="asc">升序</el-radio>
            </el-radio-group>
        </el-form-item>
    </el-form>
</template>

<script>
import { DIMENSION_FIELD_LIST } from '../../constant'
export default {
    props: [ 'optionFieldsList', 'defaultData' ],
    data() {
        const { sum_type="day", order_by, order_type="desc" } = this.defaultData
        return {
            formData: { 
                sum_type,
                order_by: order_by || 'date',
                order_type
            },
            rules: { 
                
            },
        }
    },
    computed: {
        joinOptionFieldsList() {
            return [].concat( DIMENSION_FIELD_LIST,this.optionFieldsList)
        }
    },
    methods: {
        async getFormData() {
            const valid = await this.$refs['formRef'].validate();
            if (valid) {
                return {
                    ...this.formData,
                }
            }
             
        }
    }
}
</script>

<style lang="scss" scoped>

</style>